
import { Select, Option, Checkbox } from "element-ui"
import baseDialog from "./baseDialog.vue"
import { closeAPPAndSMSNotification } from "@/api/notification"
import { sendSmsVerifyCode, login, getIsMember, signUp, updateInfo } from "@/api/authentication"
import { validatePhoneNumber } from "@/utils/auth"
import { SmsSendTypeEnum, LoginTypeEnum, LOGIN_STEP, LINK_YUU_TYPE } from "@/constants/auth"
import { openPop } from "@/utils/utils"
import ALink from "@/components/aLink.vue"
import { loadReCaptcha } from "@/utils/recaptcha"
export default {
  name: "LoginRegisterForm",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    ALink,
    baseDialog
  },
  data() {
    return {
      url: "",
      showDialog: false,
      countryCode: "+852",
      options: [
        {
          label: this.$t("auth.china"),
          value: "+86",
          maxlength: 11
        },
        {
          label: this.$t("auth.hongKong"),
          value: "+852",
          maxlength: 8
        },
        {
          label: this.$t("auth.macau"),
          value: "+853",
          maxlength: 8
        }
      ],
      phoneNumber: "",
      allowMarketing: false,
      lang: this.$i18n.locale,
      authCode: "",
      smsWait: 0,
      protocalUrl: {
        purposesProtocolUrl: "https://711-hk.rta-os.com/d/UtWhq1euEI.html",
        userProtocolUrl: "https://711-hk.rta-os.com/d/UtWhq1euEI.html",
        privacyProtocol: "https://711-hk.rta-os.com/d/UtWhq1euEI.html",
        protocolUrl: "https://711-hk.rta-os.com/d/26skVec3FES.html",
        picsProtocolUrl: "https://711-hk.rta-os.com/d/xL05MWOwXfltqo1.html"
      },
      placeholderPhone: this.$t("auth.enterPhoneNumber"),
      notificationChecked: false,
      LOGIN_STEP,
      step: LOGIN_STEP.LOGIN,
      form: {
        name: "",
        email: "",
        birth: ""
      },
      custId: "",
      isApiCallOngoing: false
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.loginOrRegister")}`
    }
  },
  computed: {
    nextDisabled() {
      return !validatePhoneNumber(this.phoneWithCountryCode)
    },
    phoneWithCountryCode() {
      return this.countryCode + " " + this.phoneNumber
    },
    phoneMaxLength() {
      return this.options.find(option => option.value === this.countryCode).maxlength
    },
    phoneWithxxxx() {
      return this.phoneWithCountryCode.replace(/(.*)\d{4}(\d{4})/, "$1****$2")
    }
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    },
    async submitPhoneForm() {
      if (this.isApiCallOngoing) return
      this.isApiCallOngoing = true
      if (!validatePhoneNumber(this.phoneWithCountryCode)) {
        // Toast.fail(this.$t("auth.invalidPhoneNumber"))
        return
      }
      const res = await getIsMember({
        phone: this.phoneWithCountryCode,
        loginChannel: this.$appConfig.loginChannel
      })
      this.isApiCallOngoing = false
      if (res.data?.id) {
        this.gotoOTPLoginStep()
      } else {
        this.gotoYuuStep()
      }
    },
    gotoYuuStep() {
      this.step = LOGIN_STEP.LINK_YUU
    },
    gotoOTPLoginStep() {
      this.step = LOGIN_STEP.OTP_LOGIN
      this.initOPT()
    },
    // click skip
    gotoOTPSignUpStep() {
      this.$messageBox
        .open({
          title: this.$t("auth.notContinueYuu"),
          message: this.$t("auth.notContinueYuuContent"),
          confirmText: this.$t("auth.skipYuu"),
          cancelText: this.$t("auth.letMeThink"),
          showClose: false,
          disMaskClick: true
        })
        .then(() => {
          this.step = LOGIN_STEP.OTP_SIGN_UP
          this.initOPT()
        })
    },
    handleClickSMSBack() {
      if (this.step === LOGIN_STEP.OTP_LOGIN) {
        this.step = LOGIN_STEP.LOGIN
      } else {
        this.step = LOGIN_STEP.LINK_YUU
      }
    },
    gotoLoginStep() {
      this.step = LOGIN_STEP.LOGIN
    },
    handleClickContinue() {
      let redirect = this.$route.query.redirect
      if (!redirect) {
        redirect = `${window.location.origin}`
      }
      openPop(redirect, this.phoneWithCountryCode, LINK_YUU_TYPE.SIGN_UP)
    },
    goRewardPage() {
      const lang = this.$i18n.locale
      if (lang === "zh_HK") {
        window.open("https://www.yuurewards.com/zh-hant/rewards")
      } else {
        window.open("https://www.yuurewards.com/en/rewards")
      }
    },
    initOPT() {
      this.handleSmsSend()
      if ("OTPCredential" in window) {
        const input = this.$refs.otpInput
        // Cancel the WebOTP API if the form is submitted manually.
        const ac = new AbortController()
        const form = input.closest("form")
        if (form) {
          form.addEventListener("submit", e => {
            // Cancel the WebOTP API.
            ac.abort()
          })
        }
        // Invoke the WebOTP API
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal
          })
          .then(otp => {
            this.authCode = otp.code
            // Automatically submit the form when an OTP is obtained.
            if (form) form.submit()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    submitLoginForm() {
      if (this.step === LOGIN_STEP.OTP_LOGIN) {
        this.handleLogin()
      } else {
        this.handleSignUp()
      }
    },
    async handleLogin() {
      if (this.isApiCallOngoing) return
      this.isApiCallOngoing = true
      if (!this.authCode) {
        // Toast.fail(this.$t("auth.enterSMSCode"))
        return
      }
      try {
        const response = await login({
          phone: this.phoneWithCountryCode,
          loginType: LoginTypeEnum.sms,
          authCode: this.authCode,
          // 保持登录
          keepactive: 1,
          deviceId: btoa(navigator.userAgent),
          domain: window.location.hostname,
          loginChannel: this.$appConfig.loginChannel
        })
        this.$message.success(this.$t("common.loginInSuccess"))
        this.handleNotificaton()
        this.redirectToPage()
      } catch (error) {
        this.$message.error(error.result)
        console.log(error)
      } finally {
        this.isApiCallOngoing = false
      }
    },
    redirectToPage() {
      if (this.$route.query?.redirect?.includes(window.location.hostname)) {
        window.location.href = this.$route.query.redirect || "/"
      } else {
        window.location.href = "/"
      }
    },
    async handleSignUp() {
      try {
        const response = await signUp({
          phone: this.phoneWithCountryCode,
          authCode: this.authCode,
          domain: window.location.hostname,
          loginChannel: this.$appConfig.loginChannel
        })
        this.custId = response.data.id
        this.$message.success(this.$t("common.signUpSuccess"))
        this.handleNotificaton()
        this.step = LOGIN_STEP.UPDATE_PERSONAL_INFO
      } catch (error) {
        this.$message.error(error.result)
        console.error(error)
      }
    },
    async handleNotificaton() {
      if (this.notificationChecked) {
        try {
          await closeAPPAndSMSNotification(this.phoneWithCountryCode)
        } catch (error) {
          console.error(error)
        }
      }
    },
    getRiskControlParams() {
      return {
        deviceId: btoa(navigator.userAgent)
      }
    },

    async handleSmsSend() {
      if (this.isApiCallOngoing) return
      this.isApiCallOngoing = true
      try {
        // 加载 Google reCAPTCHA 脚本并等待加载完成
        const grecaptcha = await loadReCaptcha()
        // 2. 谷歌不出问题的情况，token返回失败或者有问题
        let reCaptchaToken = ""

        try {
          await new Promise(resolve => grecaptcha.enterprise.ready(resolve))
          reCaptchaToken = await grecaptcha.enterprise.execute("6Ld88nQrAAAAAHHD-OtUpGI0zN65ybxk3D2pcij5", {
            action: "login"
          })
          if (!reCaptchaToken) {
            throw new Error("reCAPTCHA token is empty")
          }
          console.log("reCAPTCHA token:", reCaptchaToken)
        } catch (error) {
          console.warn("reCAPTCHA failed, using empty token", error)
          // 继续执行，不中断流程
        }
        const { code, data } = await sendSmsVerifyCode({
          phone: this.phoneWithCountryCode,
          smsType: SmsSendTypeEnum.login,
          reCaptchaToken,
          loginChannel: this.$appConfig.loginChannel,
          ...this.getRiskControlParams()
        })
        this.smsWait = 60
        this.timmer = setInterval(() => {
          this.smsWait = this.smsWait - 1
          if (this.smsWait === 0) {
            clearInterval(this.timmer)
            this.smsWait = 0
          }
        }, 1000)
        if (code === "40001") {
          this.showDialog = true
          this.url = data
        }
      } catch (error) {
        // 1. 谷歌出问题的情况，初始化失败
        if (error === "failed") {
          try {
            const { code, data } = await sendSmsVerifyCode({
              phone: this.phoneWithCountryCode,
              smsType: SmsSendTypeEnum.login,
              reCaptchaToken: "",
              loginChannel: this.$appConfig.loginChannel,
              ...this.getRiskControlParams()
            })
            this.smsWait = 60
            this.timmer = setInterval(() => {
              this.smsWait = this.smsWait - 1
              if (this.smsWait === 0) {
                clearInterval(this.timmer)
                this.smsWait = 0
              }
            }, 1000)
            if (code === "40001") {
              this.showDialog = true
              this.url = data
            }
          } catch (error) {
          } finally {
            this.isApiCallOngoing = false
          }
        }
      } finally {
        this.isApiCallOngoing = false
      }
    },
    handleClickClose() {
      this.$navigation.replace("/account")
    },
    handleChanged(updatedFormData) {
      this.form = updatedFormData
    },
    async handleUpdate() {
      try {
        const res = await updateInfo({
          custId: this.custId,
          ...this.form,
          email: encodeURIComponent(this.form.email || ""),
          loginChannel: this.$appConfig.loginChannel
        })
        if (res.code == "0000") {
          // Toast.success(this.$t("common.updateSuccessfully"))
          this.redirectToPage()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
